import I18n from "i18n-js";
import React from "react";

export default class EllipsedString extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data && typeof this.props.data !== 'undefined') {
      var htmlString = this.props.data.length <= 135 ? this.props.data : this.ellipseString(this.props.data)
      return (
        <div dangerouslySetInnerHTML={{ __html: htmlString }} className="StringDataType"></div>
      );
    } else {
      return (
        <div className="none">{I18n.t('none')}</div>
      )
    };
  };

  ellipseString = (string) => {
    return string.match(/.{1,127}/g)[0] + I18n.t('ellipsis')
  };
  
};


